import router from '@/router';
import store from '@/store';
import defaultSettings from './settings';

function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${defaultSettings.title}`;
  }

  return defaultSettings.title;
}


router.beforeEach(async(to, from, next) => {
    document.title = getPageTitle(to.meta.title);

    next();
});